import { error } from '../actions';
import {
	getUserSettings as getUserSettingsService,
	updateUserSettings as updateUserSettingsService,
} from '../services/userSettings.service';
import { UserSettings } from '../types';
import { AxiosResponse } from 'axios';
import { put, retry, takeLatest } from 'redux-saga/effects';
import {
	getUserSettings,
	userSettingsResolved,
	userSettingsRejected,
	updateUserSettings,
	updateUserSettingsResolved,
	updateUserSettingsRejected,
} from '../actions/userSettings.actions';
import { PayloadAction } from '@reduxjs/toolkit';

function* getUserSettingsSaga() {
	try {
		const response: AxiosResponse<UserSettings> = yield retry(
			2,
			10000,
			getUserSettingsService,
		);
		if (response.data) {
			yield put(userSettingsResolved(response.data));
		} else {
			yield put(userSettingsRejected());
			yield put(error('Failed to get user settings'));
		}
	} catch (e) {
		yield put(userSettingsRejected());
		yield put(error('Failed to get user settings'));
	}
}

function* watchGetUserSettingsSaga() {
	yield takeLatest(getUserSettings, getUserSettingsSaga);
}

function* updateUserSettingsSaga(action: PayloadAction<Partial<UserSettings>>) {
	try {
		const response: AxiosResponse<UserSettings> = yield retry(
			2,
			10000,
			() => updateUserSettingsService(action.payload),
		);
		if (response.data) {
			yield put(updateUserSettingsResolved(response.data));
		} else {
			yield put(updateUserSettingsRejected());
			yield put(error('Failed to update user settings'));
		}
	} catch (e) {
		yield put(updateUserSettingsRejected());
		yield put(error('Failed to update user settings'));
	}
}
function* watchUpdateUserSettingsSaga() {
	yield takeLatest(updateUserSettings, updateUserSettingsSaga);
}

export default [watchGetUserSettingsSaga(), watchUpdateUserSettingsSaga()];
